/*
 * Text-input skin for the enrollment-flow screens. Callers append a text color
 * and INPUT_ERROR_SKIN with plain template strings, not cn(): tailwind-merge
 * can't tell the custom text-size tokens from text-* colors and drops one.
 */
export const INPUT_SKIN =
  "text-step bg-glacier border-drift placeholder:text-placeholder h-[45px] w-full rounded-[10px] border-[0.556px] px-4 focus:border-midnight focus:bg-white focus:outline-none";
export const INPUT_ERROR_SKIN = " border-danger/40 bg-danger-bg focus:border-danger";
